import { Link } from "react-router-dom";
import { useQuery, getMyPlatformBuildings } from "wasp/client/operations";
import { ExternalLink, Building2, ChevronRight } from "lucide-react";

/** Compact reception teaser linking to the portfolio hub. */
export default function MyBuildingsCard() {
  const { data, isLoading } = useQuery(getMyPlatformBuildings);
  const payload = data as any;

  if (isLoading) return null;
  if (!payload?.configured) return null;

  const buildings = payload.buildings || [];
  if (buildings.length === 0) return null;

  const preview = buildings.slice(0, 3);
  const more = buildings.length - preview.length;

  return (
    <section className="rounded-2xl border border-sky-200 bg-sky-50/60 p-4">
      <div className="mb-2 flex items-start justify-between gap-2">
        <div className="flex items-center gap-2">
          <Building2 className="h-4 w-4 text-sky-700" />
          <h2 className="text-sm font-semibold text-sky-900">
            Your other buildings
          </h2>
        </div>
        <Link
          to="/my-buildings"
          className="inline-flex min-h-9 shrink-0 items-center gap-0.5 text-xs font-semibold text-sky-800"
        >
          View all
          <ChevronRight className="h-3.5 w-3.5" />
        </Link>
      </div>
      <p className="mb-3 text-xs text-sky-800">
        Linked via your platform identity
        {payload.email ? ` (${payload.email})` : ""}.
      </p>
      <ul className="space-y-2">
        {preview.map((b: any) => {
          const url = b.instance?.customDomain || b.instance?.appUrl;
          return (
            <li
              key={b.instance?.id || b.instance?.slug}
              className="flex flex-wrap items-center justify-between gap-2 rounded-xl bg-white px-3 py-2.5 text-sm"
            >
              <div className="min-w-0">
                <p className="truncate font-medium text-neutral-900">
                  {b.instance?.brandName || b.instance?.name}
                </p>
                <p className="text-xs text-neutral-500">
                  {b.instance?.slug} · {b.role}
                </p>
              </div>
              {url ? (
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex min-h-9 items-center gap-1 text-xs font-semibold text-sky-700"
                >
                  Open <ExternalLink className="h-3 w-3" />
                </a>
              ) : (
                <span className="text-xs text-neutral-400">URL pending</span>
              )}
            </li>
          );
        })}
      </ul>
      {more > 0 && (
        <Link
          to="/my-buildings"
          className="mt-3 block text-center text-xs font-semibold text-sky-800"
        >
          +{more} more in portfolio
        </Link>
      )}
    </section>
  );
}
